export default __webpack_public_path__ + "static/media/mini-robot-fighter.0cc03d5b.svg";